


export default {
    mixins:[],
    props: {
        value: {},
        name: {
            type: String,
            default: "ToggleInputText"
        },
        options: {
            type: Array,
            required: true
        },
        selected: {
            type: Object,
            required: false
        },
        label: {
            type: String,
            required: false
        },
        autocomplete: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            validator: function (value) {
                return ['extra-small', 'small', 'medium', 'large', 'full'].indexOf(value) !== -1
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        isInvalid: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            required: false
        },
    },
    data: function(){
        return {
            dropdownStyle: {
                'color': '',
                "font-size": '',
                "font-weight": '',
                "font-family": '',
            }
        }
    },
    
    created : function(){
        const titleStyle = this.styleMe('vanilla', 'StoreFront', 'title-text');
        const o = titleStyle && titleStyle[1] ? titleStyle[1] : {};
        this.dropdownStyle['color'] = o['color'] || '#000000';
        this.dropdownStyle['font-size'] = '16px';
        this.dropdownStyle['font-weight'] = o['font-weight'] || 'normal';
        this.dropdownStyle['font-family'] = o['font-family'] || 'Lato';
    },
    computed: {
        inputVal: {
            get: function (){
                return this.value;
            },

            set: function (value){
                this.$emit('input', value);
            }
        },
    },
    methods: {

        onFocus() {
            this.$emit('onFocus');
        },

        onBlur(){
            this.$emit('onBlur');
        },

        focusClosestInput(event){
            if(event.target.querySelector('input, textarea') !== null) {
                event.target.querySelector('input, textarea').focus();
            }
        },
    },
}


